// extracted by mini-css-extract-plugin
export default {"pause":"src-components-___playback-status__pause___LCuz1","buffering":"src-components-___playback-status__buffering___EOigK","spin":"src-components-___playback-status__spin___jxRGy"};